import { render, staticRenderFns } from "./Postfach.vue?vue&type=template&id=5fa74287&scoped=true"
import script from "./Postfach.vue?vue&type=script&lang=js"
export * from "./Postfach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa74287",
  null
  
)

export default component.exports